module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nezet.tipus == 'kitoltesek'),
      expression: "nezet.tipus == 'kitoltesek'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("\n              Jegyzettámogatás\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "article-text"
  }, _vm._l((_vm.idoszakok), function(idoszak, i) {
    return _c('div', {
      staticClass: "info-box"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(idoszak.azonosito))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-direction": "column",
        "align-items": "flex-start"
      }
    }, [((idoszak.beadott_palyazat == false && idoszak.elbiralt_palyazat == false) || (idoszak.beadott_palyazat != false && _vm.aktiv_idoszak == false && ['MENTVE'].includes(idoszak.beadott_palyazat.statusz_kulcs))) ? _c('div', {
      staticStyle: {
        "padding-bottom": "10px"
      }
    }, [_vm._v("Nem található pályázat.")]) : _vm._e(), _vm._v(" "), (idoszak.beadott_palyazat != false && ['VEGLEGESITVE'].includes(idoszak.beadott_palyazat.statusz_kulcs)) ? _c('button', {
      staticClass: "button",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "disabled": _vm.pdf_generalas_folyamatban,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.pdfGeneralas(idoszak.beadott_palyazat.id)
        }
      }
    }, [_vm._v("Beadott pályázatom (Pdf)")]) : _vm._e(), _vm._v(" "), (idoszak.elbiralt_palyazat != false && ['ELFOGADVA', 'ELUTASITVA'].includes(idoszak.elbiralt_palyazat.statusz_kulcs)) ? _c('button', {
      staticClass: "button",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "disabled": _vm.pdf_generalas_folyamatban,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.pdfGeneralas(idoszak.elbiralt_palyazat.id)
        }
      }
    }, [_vm._v("Elbírált pályázatom (" + _vm._s(idoszak.elbiralt_palyazat.statusz_megnevezes) + ") (Pdf)")]) : _vm._e(), _vm._v(" "), (_vm.aktiv_idoszak != false && _vm.aktiv_idoszak.id == idoszak.id && idoszak.beadott_palyazat == false && idoszak.elbiralt_palyazat == false) ? _c('button', {
      staticClass: "button",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "disabled": _vm.pdf_generalas_folyamatban,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.palyazatUrlapMegjelenites()
        }
      }
    }, [_vm._v("Új Pályázat leadása")]) : _vm._e(), _vm._v(" "), (_vm.aktiv_idoszak != false && _vm.aktiv_idoszak.id == idoszak.id && idoszak.beadott_palyazat != false && idoszak.elbiralt_palyazat == false && ['MENTVE'].includes(idoszak.beadott_palyazat.statusz_kulcs)) ? _c('button', {
      staticClass: "button",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "disabled": _vm.pdf_generalas_folyamatban,
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.palyazatUrlapMegjelenites()
        }
      }
    }, [_vm._v("Pályázat módosítása")]) : _vm._e()])])
  }))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nezet.tipus == 'urlap'),
      expression: "nezet.tipus == 'urlap'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "nev",
      "name": "nev",
      "disabled": "",
      "label": "Név"
    },
    model: {
      value: (_vm.form.nev),
      callback: function($$v) {
        _vm.form.nev = $$v
      },
      expression: "form.nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "neptunkod",
      "name": "neptunkod",
      "disabled": "",
      "label": "Neptun azonosító"
    },
    model: {
      value: (_vm.form.neptunkod),
      callback: function($$v) {
        _vm.form.neptunkod = $$v
      },
      expression: "form.neptunkod"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "szuletesiHely",
      "name": "szuletesiHely",
      "disabled": "",
      "label": "Születési hely"
    },
    model: {
      value: (_vm.form.szuletesiHely),
      callback: function($$v) {
        _vm.form.szuletesiHely = $$v
      },
      expression: "form.szuletesiHely"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "szuletesiIdo",
      "name": "szuletesiIdo",
      "disabled": "",
      "label": "Születési idő"
    },
    model: {
      value: (_vm.form.szuletesiIdo),
      callback: function($$v) {
        _vm.form.szuletesiIdo = $$v
      },
      expression: "form.szuletesiIdo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "anyjaNeve",
      "name": "anyjaNeve",
      "disabled": "",
      "label": "Anyja neve"
    },
    model: {
      value: (_vm.form.anyjaNeve),
      callback: function($$v) {
        _vm.form.anyjaNeve = $$v
      },
      expression: "form.anyjaNeve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "telefonszam",
      "name": "telefonszam",
      "disabled": "",
      "label": "Telefonszám"
    },
    model: {
      value: (_vm.form.telefonszam),
      callback: function($$v) {
        _vm.form.telefonszam = $$v
      },
      expression: "form.telefonszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "emailCim",
      "name": "emailCim",
      "disabled": "",
      "label": "E-mail cím"
    },
    model: {
      value: (_vm.form.emailCim),
      callback: function($$v) {
        _vm.form.emailCim = $$v
      },
      expression: "form.emailCim"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Képzések",
      "id": "kepzesKodja",
      "options": _vm.kepzesek
    },
    on: {
      "onChange": _vm.kepzesValt
    },
    model: {
      value: (_vm.form.kivalasztottKepzesKodja),
      callback: function($$v) {
        _vm.form.kivalasztottKepzesKodja = $$v
      },
      expression: "form.kivalasztottKepzesKodja"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kar",
      "name": "kar",
      "disabled": "",
      "label": "Kar neve"
    },
    model: {
      value: (_vm.form.kar),
      callback: function($$v) {
        _vm.form.kar = $$v
      },
      expression: "form.kar"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "tagozat",
      "name": "tagozat",
      "disabled": "",
      "label": "Tagozat"
    },
    model: {
      value: (_vm.form.tagozat),
      callback: function($$v) {
        _vm.form.tagozat = $$v
      },
      expression: "form.tagozat"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kepzesNeve",
      "name": "kepzesNeve",
      "disabled": "",
      "label": "Képzés"
    },
    model: {
      value: (_vm.form.kepzesNeve),
      callback: function($$v) {
        _vm.form.kepzesNeve = $$v
      },
      expression: "form.kepzesNeve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kepzesKodja",
      "name": "kepzesKodja",
      "disabled": "",
      "label": "Képzés kódja"
    },
    model: {
      value: (_vm.form.kepzesKodja),
      callback: function($$v) {
        _vm.form.kepzesKodja = $$v
      },
      expression: "form.kepzesKodja"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kepzesSzintje",
      "name": "kepzesSzintje",
      "disabled": "",
      "label": "Képzés szintje"
    },
    model: {
      value: (_vm.form.kepzesSzintje),
      callback: function($$v) {
        _vm.form.kepzesSzintje = $$v
      },
      expression: "form.kepzesSzintje"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "hallgatoiStatusz",
      "name": "hallgatoiStatusz",
      "disabled": "",
      "label": "Hallgatói státusz"
    },
    model: {
      value: (_vm.form.hallgatoiStatusz),
      callback: function($$v) {
        _vm.form.hallgatoiStatusz = $$v
      },
      expression: "form.hallgatoiStatusz"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kepzesHelye",
      "name": "kepzesHelye",
      "disabled": "",
      "label": "Képzés helye"
    },
    model: {
      value: (_vm.form.kepzesHelye),
      callback: function($$v) {
        _vm.form.kepzesHelye = $$v
      },
      expression: "form.kepzesHelye"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "penzugyiStatusz",
      "name": "penzugyiStatusz",
      "disabled": "",
      "label": "Pénzügyi státusz"
    },
    model: {
      value: (_vm.form.penzugyiStatusz),
      callback: function($$v) {
        _vm.form.penzugyiStatusz = $$v
      },
      expression: "form.penzugyiStatusz"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "osztondijindex",
      "name": "osztondijindex",
      "disabled": "",
      "label": "Ösztöndíjindex"
    },
    model: {
      value: (_vm.form.osztondijindex),
      callback: function($$v) {
        _vm.form.osztondijindex = $$v
      },
      expression: "form.osztondijindex"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Melyik jegyzeteketre szeretnél támogatást igénybe venni?\n          ")]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.jegyzetIdk.length > 0),
      expression: "form.jegyzetIdk.length > 0"
    }],
    staticClass: "list-table list-table-stripped"
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.form.jegyzetIdk), function(jegyzetId, i) {
    return _c('tr', {
      key: 'jegyzet_' + i
    }, [_c('td', [_vm._v("\n                " + _vm._s(_vm.jegyzetAzonosito(jegyzetId)) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.jegyzetMegnevezes(jegyzetId)) + "\n              ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.jegyzetBruttoAr(jegyzetId)) + "\n              ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button only-icon",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.jegyzetTorol(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "sum"
  }, [_vm._m(5), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.jegyzetArOsszesen))])]), _vm._v(" "), _c('td')])], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Jegyzet",
      "id": "hozzaadandojegyzetId",
      "errors": _vm.errors,
      "options": _vm.hozzaadhatoJegyzetek
    },
    model: {
      value: (_vm.hozzaadandojegyzetId),
      callback: function($$v) {
        _vm.hozzaadandojegyzetId = $$v
      },
      expression: "hozzaadandojegyzetId"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button only-icon",
    attrs: {
      "disabled": _vm.hozzaadandojegyzetId == '0',
      "type": "button"
    },
    on: {
      "click": _vm.jegyzetHozzaad
    }
  }, [_vm._v("+")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('textareabox', {
    attrs: {
      "autogrow": true,
      "maxlength": "5000",
      "label": "",
      "errors": _vm.errors,
      "id": "megjegyzes",
      "name": "megjegyzes"
    },
    model: {
      value: (_vm.form.megjegyzes),
      callback: function($$v) {
        _vm.form.megjegyzes = $$v
      },
      expression: "form.megjegyzes"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.nyilatkozatElfogadas),
      expression: "form.nyilatkozatElfogadas"
    }],
    attrs: {
      "true-value": "1",
      "false-value": "0",
      "id": "nyilatkozatElfogadas",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.nyilatkozatElfogadas) ? _vm._i(_vm.form.nyilatkozatElfogadas, null) > -1 : _vm._q(_vm.form.nyilatkozatElfogadas, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.nyilatkozatElfogadas,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.nyilatkozatElfogadas = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.nyilatkozatElfogadas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.nyilatkozatElfogadas = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'nyilatkozatElfogadas') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.mentes_folyamatban,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save(0)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.mentes_folyamatban,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save(1)
      }
    }
  }, [_vm._v("Véglegesít")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nezet.tipus == 'info'),
      expression: "nezet.tipus == 'info'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("\n            Jegyzettámogatás\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.nezet.tartalom)
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("\n            Jegyzettámogatás\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n            Amennyiben hibát talál "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("személyes")]), _vm._v(" vagy "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("képzési adataiban")]), _vm._v(", kérjük lépjen kapcsolatba a tanulmányi ügyintézővel.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Személyes adatok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Képzési adatok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Cikkszám")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Megnevezés")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Bruttó ár")]), _vm._v(" "), _c('th')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Összesen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Megjegyzés\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Hallgatói nyiltakozat\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "nyilatkozatElfogadas"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                A pályázat benyújtásával büntetőjogi felelősségem teljes tudatában kijelentem, hogy hamis adatok közlése esetén fegyelmi eljárás indulhat ellenem, mely a hallgatói jogviszony fegyelmi úton történő megszüntetését is eredményezheti. Továbbá hozzájárulok ahhoz, hogy adataimat a Széchenyi István Egyetem Hallgatói Önkormányzata nevében eljáró személyek a pályázat elbírálásával összefüggésben, a TJSZ-ben rögzített feltételeknek, illetve a személyi adatok védelméről és a közérdekű adatok nyilvánosságáról szóló 1992. évi LXIII. törvénynek megfelelően kezelje.\n              ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60cda92b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/jegyzettamogatas.vue
// module id = 378
// module chunks = 0